import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BulbIcon from '@tradera/blueprint/theme/icons2/curation.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import Analytics from 'packages/analytics';

const LocalizationLinkTooltip = ({ show, onClose, children }) => {
    useEffect(() => {
        if (!show) {
            return;
        }
        Analytics.trackEvent({
            category: 'Top navigation',
            action: 'Localization menu tooltip',
            label: 'Show'
        });
    }, [show]);

    return show ? (
        <div
            className="tooltip tooltip-lg tooltip-southwest"
            onClick={() => onClose()}>
            <div className="tooltip_html">
                <BulbIcon className="tooltip_icon icon" />
                <div className="tooltip_content">{children}</div>
                <span className="tooltip_close-icon">
                    <CloseIcon className="icon icon-sm" />
                </span>
            </div>
        </div>
    ) : null;
};

LocalizationLinkTooltip.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

export const BetaLocalizationTooltip = props => (
    <LocalizationLinkTooltip {...props}>
        <p>Would you like to try Tradera in English?</p>
        <p>
            The language setting is currently in early beta and does not cover
            all sections of Tradera.
        </p>
        <p>Select English via the menu and tell us what you think!</p>
    </LocalizationLinkTooltip>
);

BetaLocalizationTooltip.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export const OptinLocalizationTooltip = props => (
    <LocalizationLinkTooltip {...props}>
        <p>Hooray! You are browsing Tradera in English! (Beta)</p>
        <p>
            The language preference has been automatically set. You may change
            this at any time.
        </p>
        <p>
            Feel free to <span className="palette-color-1">leave feedback</span>{' '}
            via the menu!
        </p>
    </LocalizationLinkTooltip>
);

OptinLocalizationTooltip.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
